import { cn, Stack, StackProps } from 'component-library';
import { ReactNode } from 'react';

export const SectionWrapper = ({ children, stackProps }: { children: ReactNode; stackProps?: StackProps }) => {
  return (
    <Stack spacing={2} direction='col' {...stackProps}>
      {children}
    </Stack>
  );
};

export const SectionTitle = ({ text, className }: { text: string; className?: string }) => {
  return <span className={cn('typography-overline font-semibold', className)}>{text}</span>;
};
